import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@dowty/ui/base.css';
import '@dowty/legal/styles.css';
import './App.css';
import {applyUpdate, registerServiceWorker} from '@dowty/offline';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// The service worker (src/service-worker.ts) is only built for production; a worker in front of the dev server breaks hot reloading.
if (process.env.NODE_ENV === 'production') {
    registerServiceWorker(`${process.env.PUBLIC_URL}/service-worker.js`, {
        onUpdate: registration => {
            if (window.confirm('A new version of SportDings is available. Reload to update?')) applyUpdate(registration);
        },
    });
}
